import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section id="faq" className="max-w-3xl" data-id="element-84" data-mp="1ceqetqsvt3iv">
      <h2 className="mb-10 text-center text-2xl font-bold tracking-tight text-emerald-900 md:text-4xl" data-id="element-85" data-mp="1cg1h1m6oi37v">
        Le domande più frequenti
      </h2>
      <div className="divide-y divide-stone-200 overflow-hidden rounded-xl border border-stone-200 bg-white shadow-sm" data-id="element-86" data-mp="253f6z0bylyih">
        {faqs.map((faq, index) => <div key={faq.q} data-id="element-87" data-mp="202hpkpyrx8i1" data-mpi={index}>
            <button type="button" aria-expanded={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-stone-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-amber-400" data-id="element-88" data-mp="205vt41j6bnr2">
              <span className="pr-8 text-sm font-semibold text-emerald-900 md:text-base" data-id="element-89" data-mp="1kp1mviybsru2">{faq.q}</span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-stone-500 transition-transform duration-200 ease-out ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-90" data-mp="1plickhl6be99" />
            </button>
            <AnimatePresence initial={false} data-id="element-91" data-mp="1fnm11oobqham">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-92" data-mp="11xiip8skf7qg">
                  <div className="space-y-3 px-6 pb-5 text-sm leading-relaxed text-stone-700 md:text-base" data-id="element-93" data-mp="wyfh5ybsnjn8">
                    {faq.a.map(paragraph => <p key={paragraph} data-id="element-94" data-mp="mzq7gsu1x5i2">{paragraph}</p>)}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}